import { render, staticRenderFns } from "./g-listtop.vue?vue&type=template&id=f629acb2&scoped=true"
import script from "./g-listtop.vue?vue&type=script&lang=js"
export * from "./g-listtop.vue?vue&type=script&lang=js"
import style0 from "./g-listtop.vue?vue&type=style&index=0&id=f629acb2&prod&lang=less&scoped=true"
import style1 from "./g-listtop.vue?vue&type=style&index=1&id=f629acb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f629acb2",
  null
  
)

export default component.exports